import { useMemo } from 'react';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
/** Hook to get widget feature-flag states by widget type. */
export function usePartnerWidgetFeatureFlags() {
    const featureFlags = useFeatureFlag([
        'partner-integrations-widget-jira',
        'partner-integrations-widget-shopify',
        'partner-integrations-widget-sample',
        'partner-integrations-widget-github',
        'partner-integrations-widget-miuros',
        'partner-integrations-widget-linear',
        'partner-integrations-widget-klaviyo',
    ]);
    return useMemo(() => ({
        JIRA: featureFlags.partnerIntegrationsWidgetJira,
        SHOPIFY: featureFlags.partnerIntegrationsWidgetShopify,
        SAMPLE: featureFlags.partnerIntegrationsWidgetSample,
        GITHUB: featureFlags.partnerIntegrationsWidgetGithub,
        MIUROS: featureFlags.partnerIntegrationsWidgetMiuros,
        LINEAR: featureFlags.partnerIntegrationsWidgetLinear,
        KLAVIYO: featureFlags.partnerIntegrationsWidgetKlaviyo,
    }), [featureFlags]);
}
